import * as React from "react";
import {Component } from "react";

import {observer} from "mobx-react";
import _ from "lodash";
import {Item, Table} from "semantic-ui-react";
import SVG from "react-inlinesvg";
import rightArrow from "../../../../assets/images/layout/right-arrow.svg";

export interface ProjektTableProps {
    data: ProjektDataItem[];
    handleShowProjekt: (bagenr: string, event: React.MouseEvent) => void;
    title?: string;
}
export interface ProjektDataItem {
    bagenr: string;
    gegenstand: string;
    status: string;
}
interface SortAction {
    type: string;
    column: string;
}
@observer
export class ProjektTable extends Component<ProjektTableProps, any> {
    watchHandles: any[] = [];
    constructor(props: ProjektTableProps) {
        super(props);
        this.state = {
            column: "bagenr",
            data: _.orderBy(this.props.data, ["bagenr"], ["desc"]),
            direction: "descending"
        };
        this.sort = this.sort.bind(this);
    }
    sort(action: SortAction): void {
        // console.log(action);
        switch (action.type) {
        case "CHANGE_SORT":
            if (this.state.column === action.column) {
                this.setState({
                    ...this.state,
                    data: this.state.data.reverse(),
                    direction:
                            this.state.direction === "ascending" ? "descending" : "ascending"
                });
            } else {
                this.setState({
                    column: action.column,
                    data: _.sortBy(this.state.data, [action.column]),
                    direction: "ascending",
                });
            }
            return;
        default:
            throw new Error();
        }
    }
    showProjekt(bagenr: string, event: React.MouseEvent): void {
        this.props.handleShowProjekt(bagenr, event);
    }
    componentWillUnmount(): void {
        this.watchHandles.forEach((handle: any) => {
            handle.remove();
        });
        this.watchHandles.length = 0;
    }
    render(): React.ReactElement | null {
        const { column, data, direction } = this.state;
        if (data === null ){
            return null;
        }
        let title: string;
        if (this.props.title) {
            title = this.props.title;
        } else {
            title = "Bauprojekte auf diesem Grundstück";
        }
        if (data.length === 0) {
            return (
                <Item><Item.Content><Item.Header as="h3">{title}</Item.Header>
                    <p>keine</p>
                </Item.Content></Item>);
        }
        return (
            <Item><Item.Content><Item.Header as="h3">{title}</Item.Header>
                <Table basic="very" sortable={(data.length > 1)} compact className={"projekte"}>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell singleLine
                                sorted={column === "bagenr" ? direction : null}
                                onClick={() => this.sort({ type: "CHANGE_SORT", column: "bagenr" })}>
                            Dossier-Nr.</Table.HeaderCell>
                            <Table.HeaderCell sorted={column === "gegenstand" ? direction : null}
                                onClick={() => this.sort({ type: "CHANGE_SORT", column: "gegenstand" })}>
                            Bezeichnung</Table.HeaderCell>
                            <Table.HeaderCell colSpan={2} sorted={column === "status" ? direction : null}
                                onClick={() => this.sort({ type: "CHANGE_SORT", column: "status" })}>
                            Status</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {data.map(({ bagenr, gegenstand, status }: ProjektDataItem, index: number) => (
                            <Table.Row key={bagenr + index} onClick={(event: React.MouseEvent) =>
                                this.showProjekt(bagenr, event)}>
                                <Table.Cell singleLine>{bagenr}</Table.Cell>
                                <Table.Cell>{gegenstand}</Table.Cell>
                                <Table.Cell singleLine className={"status"}>{status}</Table.Cell>
                                <Table.Cell>
                                    <span className={"sprite sprite--right-arrow"}><SVG src={rightArrow} /></span>
                                </Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body></Table>
            </Item.Content></Item>
        );
    }
}
